<template>
    <div>
        <main class="main-content main-content-specials" v-if="especial">
            <div class="container-fluid container-specials">
                <div class="row">
                    <div class="col-12">
                        <p class="specials-title"><strong>Especiais</strong></p>
                    </div>
                </div>
            </div>

            <div class="container-fluid container-featured-image" v-if="especial">
                <div class="row">
                    <div class="col-12">
                        <div class="container-featured-image__wrapper">
                        <img v-if="especial.image" :src="utils.image(especial.image, 1440, 496)" alt="">
                        <div class="featured-image__infos">
                            <p class="featured-image__title">{{especial.title}}</p>
                            <p class="featured-image__subtitle">{{especial.subtitle}}</p>
                            <p class="featured-image__author">{{especial.signature || especial.source}}</p>
                            <span class="special-arrow-down"></span>
                        </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- BLOCKS -->
            <template v-for="(item,key) in especial.content">
                
                <SimpleText 
                    v-if="item.type == 'text'" 
                    :value="item.value" 
                    :key="key" />
                
                <SimpleText 
                    v-else-if="item.type == 'text_background'" 
                    :value="item.value.text" 
                    :color="item.value.color"
                    :key="key" />
                
                <ImageFull
                    v-else-if="item.type == 'image_full'"
                    :value="item.value"
                    :key="key" />
                
                <TwoColumn
                    v-else-if="item.type == 'two_column'"
                    :value="item.value"
                    :key="key" />
                
                <TwoColumnImage
                    v-else-if="item.type == 'two_column_image'"
                    :value="item.value"
                    :key="key" />
                
                <div class="container" v-else-if="item.type=='gallery'" 
                    :key="key" >
                    <Carousel :value="item.value" />
                </div>

                <div class="container" v-else-if="item.type=='video'" :key="key">
                    <Video :value="item.value" />
                </div>

                <div class="container" v-else-if="item.type=='embed'" :key="key">
                    <Embed :value="item.value" />
                </div>

            </template>
            
            <div class="container">
                <div class="row">
                    <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-4 col-xl-7 offset-xl-2">
                        <ul class="content-tags">
                            <li v-for="(tag,key) in especial.tags" :key="key">
                                <a href="#" @click.prevent="$root.$emit('gazetaweb:search',tag)">{{tag}}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="container">
                <div class="row row-seetoo">
                    <div class="col-12">
                        <div class="content-seetoo">
                            <h2 class="title-blue">Veja também</h2>
                        </div>
                    </div>

                    <template v-for="(related,key) in related">
                        <div :class="{'col-12 col-md-4 col-lg-3':true,'offset-lg-1':key % 3 === 0}"  :key="key">
                            <router-link class="noticies" 
                                :to="related.url" v-if="related">
                                <figure v-if="related.image">
                                    <img :src="utils.image(related.image, width=256, height=136)" alt="">
                                </figure>
                                <p class="noticies__label">{{related.hat}}</p>
                                <p class="noticies__title">{{related.title}}</p>
                            </router-link>
                        </div>
                    </template>
                </div>

                <div class="row facebook-coments">
                    <div class="col-12">
                        <h2>Comentários</h2>
                    </div>
                    <div class="col-12">
                        <div class="fb-comments" :data-href="permalink" data-width="" data-numposts="5"></div>
                    </div>
                </div>
            </div>
        </main>

        <NotFound v-if="NOT_FOUND" />
        <Error v-if="ERROR" />
    </div>
</template>

<script>
import page from '@/api/page'
import utils from '@/utils'

import SimpleText from '@/components/blocks/especiais/SimpleText'
import ImageFull from '@/components/blocks/especiais/ImageFull'
import TwoColumn from '@/components/blocks/especiais/TwoColumn'
import TwoColumnImage from '@/components/blocks/especiais/TwoColumnImage'
import Carousel from '@/components/blocks/Carousel'
import Video from '@/components/blocks/Video'
import Embed from '@/components/blocks/Embed'

import NotFound from '@/views/NotFound'
import Error from '@/views/Error'

export default {
    name: "Detail",
    props:['content'],
    components:{
        SimpleText, 
        ImageFull, 
        TwoColumn, 
        TwoColumnImage, 
        Carousel, 
        Video,
        Embed,
        NotFound, 
        Error
    },
    head: {
        title: function() {
            return{
                inner:this.title
            }
        }
    },
    data() {
        return {
            utils:utils,
            especial: null,
            related: null,
            title: '',
            permalink: null,
            NOT_FOUND: false,
            ERROR: false,
        }
    },
    watch:{
        especial: function() {
            if (this.especial) {
                this.title = this.especial.title
                this.related = this.especial.related.concat(this.especial.related_extra)
                this.permalink = `${window.location.origin}/permalink/${this.especial.id}`
                window.FB.XFBML.parse()
                this.$emit('updateHead')
            }
        }
    },
    methods:{
        async getEspecial() {
            
            if (!this.content) {
                const response = await page.get(`find?html_path=${this.$route.path}`)
    
                if(response.ok) {
                    this.especial = response.data
                    this.ping()
                } else {
                    if (response.status === 404) {
                        this.NOT_FOUND = true
                    } else if (response.status >= 500) {
                        this.ERROR = true
                    }
                }
            } else {
                this.especial = this.content
            }
        },
        ping(){
            page.get(`${this.especial.id}/ping/`)
        },
    },
    mounted() {
        this.getEspecial()
    }
}
</script>